Vue.component('errors', {
    props: {
        errors: Array
    },
    template: `
            <div class="errors">
                <div class="error" v-for="error in errors">
                    {{error}}
                </div>
            </div>
    `,
});

Vue.component('proms-form-widget', {
    props: {},
    data() {
        return {
            loading: false,
            errorMap: ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"],
            form: {
                surgeon_name: "",
                patient_name: "",
                patient_phone: "",
                location: "",
                procedure: "",
                procedure_date: "",
                external_id: "",
                follow_up_30_and_180: false,
                demo: {
                    url: '',
                },
            },
            errors: {}
        }
    },
    template: `
           <form  action="">
                <fieldset :disabled="loading">
                <div class="alert alert-success" v-if="form.demo && form.demo.url.length" role="alert">
                    Success! A demo message has been sent to the Patient mobile number. To view the survey <a target="_blank" :href="form.demo.url"> click here</a>
                </div>
                <div class="d-flex  flex-wrap">
                    <div class="form-group flex-grow-1 basis-5">
                        <label for="patient-first-name">First name</label>
                        <input type="text" class="form-control " v-model="form.patient_name" id="patient-first-name">
                        <div class="sub-text">
                            Used to personalise PROMS messages.
                        </div>
                        <errors :errors="errors.patient_name" />
                    </div>
                    <div class="form-group flex-grow-1 basis-6 intl-tel-input" >
                        <label class="d-block" for="patient-mobile-number">Patient mobile number</label>
                        <input @keyup="reset" class="form-control w-100 " @change="reset" id="phone" type="tel">
                        <span id="valid-msg" class="hide">✓ Valid</span>
                        <span id="error-msg" class="hide"></span>
                        <div class="sub-text">Survey is sent via SMS</div>
                        <errors :errors="errors.patient_phone" />
                    </div>
                </div>
                <div class="d-flex  flex-wrap">
                    <div class="form-group">
                        <button  :disabled="loading" :class="{spinner: loading}" class=" btn btn-success" type="submit" @click="submit">Send Demo Survey</button>
                        <errors :errors="errors.general" />
                    </div>
                </div>
                </fieldset>

            </form>
    `,

    methods: {
        submit(e) {
            e.preventDefault();
            this.loading = true;
            this.clearErrors();
            axios.post('/demo', this.form)
                .then(response => {
                    if (typeof response.data.errors === "undefined") {
                        this.form = {
                            ...this.form,
                            ...response.data[0]
                        }
                        this.loading = false;
                        console.error(this.form.demo.url);
                    } else {
                        this.errors = response.data.errors;
                        this.loading = false;
                    }
                })
                .catch(error => {
                    console.error(error);
                    this.loading = false;
                });
        },
        reset() {
            this.input.classList.remove("error");
            this.errorMsg.innerHTML = "";
            this.errorMsg.classList.add("hide");
            this.validMsg.classList.add("hide");
        },
        clearErrors() {
            this.errors = Object.keys(this.form).reduce((p, v) => {
                p[v] = [];
                return p;
            }, {})
        }
    },
    computed: {},
    mounted() {
        this.input = document.querySelector("#phone");
        this.errorMsg = document.querySelector("#error-msg");
        this.validMsg = document.querySelector("#valid-msg");


        this.iti = window.intlTelInput(this.input, {
            utilsScript: "js/utils.js",
            initialCountry: "auto",
            geoIpLookup: (success, failure) => {
                let countryCode = localStorage.getItem('proms-country-code');
                if (countryCode === null) {
                    $.get("https://ipinfo.io", () => {
                    }, "jsonp").always(function (resp) {
                        countryCode = (resp && resp.country) ? resp.country : "au";
                        localStorage.setItem('proms-country-code', countryCode);
                        success(countryCode);
                    });
                } else {
                    success(countryCode);
                }

            }
        });

        this.input.addEventListener('blur', () => {
            this.reset();
            if (this.input.value.trim()) {
                if (this.iti.isValidNumber()) {
                    this.form.patient_phone = this.iti.getNumber();
                    this.validMsg.classList.remove("hide");
                } else {
                    this.form.patient_phone = "";

                    this.input.classList.add("error");
                    var errorCode = this.iti.getValidationError();
                    this.errorMsg.innerHTML = this.errorMap[errorCode];
                    this.errorMsg.classList.remove("hide");
                }
            }
        });
    },
    created() {
        this.clearErrors();
    }
});
